import { useState } from "react";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";
import Button from "../../ui/Button";
import a from "./auth.module.css";

const STEP_LABELS = ["Контакты", "Аккаунт", "Проверка"];

export default function AuthRegisterFlow({
  clubName,
  backTo,
  backLabel,
  subtitle,
  perks,
  portalId = "patient",
  loading,
  error,
  onSubmit,
  footer,
  segment,
}) {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    fullName: "",
    phone: "",
    login: "",
    password: "",
  });

  const patch = (key, val) => setData((d) => ({ ...d, [key]: val }));

  const step1 = (e) => {
    e.preventDefault();
    if (!data.fullName.trim()) return;
    setStep(2);
  };

  const step2 = (e) => {
    e.preventDefault();
    if (!data.login.trim() || data.password.length < 8) return;
    setStep(3);
  };

  const finish = (e) => {
    e.preventDefault();
    onSubmit({
      fullName: data.fullName.trim(),
      phone: data.phone.trim(),
      login: data.login.trim(),
      password: data.password,
    });
  };

  return (
    <AuthShell
      modern
      backTo={backTo}
      backLabel={backLabel}
      showSwitcher={false}
      cardTitle="Регистрация"
      hint={
        subtitle ||
        (clubName
          ? `Создайте аккаунт в клубе «${clubName}» — займёт пару минут.`
          : "Создайте аккаунт клиента клуба.")
      }
      clubTag={clubName}
      stepCurrent={step}
      stepTotal={3}
      stepLabels={STEP_LABELS}
      segment={segment}
      footer={step === 3 ? footer : null}
    >
      {error ? <div className={a.errorBox}>{error}</div> : null}

      {step === 1 && (
        <form onSubmit={step1}>
          <AuthField
            label="ФИО"
            value={data.fullName}
            onChange={(e) => patch("fullName", e.target.value)}
            placeholder="Иванов Иван"
            autoComplete="name"
            required
          />
          <AuthField
            label="Телефон"
            value={data.phone}
            onChange={(e) => patch("phone", e.target.value)}
            placeholder="+7 …"
            autoComplete="tel"
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg">
              Далее
            </Button>
          </div>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={step2}>
          <AuthField
            label="Email"
            type="email"
            value={data.login}
            onChange={(e) => patch("login", e.target.value)}
            placeholder="you@mail.ru"
            autoComplete="email"
            required
          />
          <AuthField
            label="Пароль"
            type="password"
            value={data.password}
            onChange={(e) => patch("password", e.target.value)}
            placeholder="Минимум 8 символов"
            autoComplete="new-password"
            minLength={8}
            required
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg">
              Далее
            </Button>
            <Button type="button" variant="ghost" block onClick={() => setStep(1)}>
              Назад
            </Button>
          </div>
        </form>
      )}

      {step === 3 && (
        <form onSubmit={finish}>
          <div className={a.reviewBox}>
            <div className={a.reviewRow}>
              <span className={a.reviewLabel}>Имя</span>
              <span className={a.reviewValue}>{data.fullName}</span>
            </div>
            {data.phone ? (
              <div className={a.reviewRow}>
                <span className={a.reviewLabel}>Телефон</span>
                <span className={a.reviewValueMuted}>{data.phone}</span>
              </div>
            ) : null}
            <div className={a.reviewRow}>
              <span className={a.reviewLabel}>Email</span>
              <span className={a.reviewValueMuted}>{data.login}</span>
            </div>
          </div>
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={loading}>
              {loading ? "Создаём…" : "Создать аккаунт"}
            </Button>
            <Button
              type="button"
              variant="ghost"
              block
              onClick={() => setStep(2)}
              disabled={loading}
            >
              Назад
            </Button>
          </div>
        </form>
      )}

      {step < 3 ? footer : null}
    </AuthShell>
  );
}
